export default "__VITE_ASSET__ByeneiKc__"